import { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import cc from 'classcat'

import { ImageUploadOptionsPopover } from './ImageUploadOptionsPopover'
import { UnsplashImageSearch } from '..'

type ImageUploadControlProps = {
  readonly onUnsplashSelect: (file: File) => void
  readonly onUploadClick: () => void
  readonly buttonTooltip?: string
  readonly buttonAriaLabel?: string
  readonly buttonContent?: React.ReactNode
  readonly buttonClassName?: string
  readonly imageSearchSideOffset?: number
  readonly optionsPopoverSideOffset?: number
  readonly side?: 'top' | 'bottom' | 'left' | 'right'
  readonly className?: string
  readonly zIndex?: number
}

export function ImageUploadControl({
  onUnsplashSelect,
  onUploadClick,
  buttonTooltip,
  buttonAriaLabel,
  buttonContent,
  buttonClassName,
  imageSearchSideOffset = 10,
  optionsPopoverSideOffset = 10,
  side = 'bottom',
  className = 'unsplash-search-edit-menu-popover',
  zIndex = 10,
}: ImageUploadControlProps) {
  const isUnsplashEnabled = useSelector<State, boolean>((state) =>
    state.getIn(['view', 'editorIsUnsplashEnabled'], false),
  )
  const [isChangeImageMenuOpen, setIsChangeImageMenuOpen] = useState(false)
  const [isUnsplashSearchMenuOpen, setIsUnsplashSearchMenuOpen] = useState(false)

  const virtualRef = useRef<HTMLButtonElement>(null)

  const getTriggerButton = (props?: React.ComponentProps<'button'>) => (
    <button
      title={buttonTooltip}
      aria-label={buttonAriaLabel || buttonTooltip}
      type="button"
      className={cc([buttonClassName, (isChangeImageMenuOpen || isUnsplashSearchMenuOpen) && 'active'])}
      {...props}
    >
      {buttonContent}
    </button>
  )

  return isUnsplashEnabled ? (
    <>
      <ImageUploadOptionsPopover
        isOpen={isChangeImageMenuOpen}
        onOpenChange={setIsChangeImageMenuOpen}
        onUnsplashClick={() => {
          setIsChangeImageMenuOpen(false)
          setIsUnsplashSearchMenuOpen(true)
        }}
        onUploadClick={() => {
          onUploadClick()
          setIsChangeImageMenuOpen(false)
        }}
        trigger={getTriggerButton({ ref: virtualRef })}
        className={className}
        side={side}
        sideOffset={optionsPopoverSideOffset}
        zIndex={zIndex}
      />

      <UnsplashImageSearch
        onSelect={(file) => {
          onUnsplashSelect(file)
          setIsUnsplashSearchMenuOpen(false)
        }}
        open={isUnsplashSearchMenuOpen}
        onOpenChange={setIsUnsplashSearchMenuOpen}
        virtualRef={virtualRef}
        sideOffset={imageSearchSideOffset}
        side="right"
      />
    </>
  ) : (
    getTriggerButton({ onClick: () => onUploadClick() })
  )
}
